"use strict";

if (!customElements.get("c-cart-item")) {
  customElements.define(
    "c-cart-item",
    class ComponentPopupLineItem extends HTMLElement {
      constructor() {
        super();
        this.removeBtnClickHandler = this.removeBtnClickHandler.bind(this);
        this.qtyInputChangeHandler = this.qtyInputChangeHandler.bind(this);
        this.qtyButtonPlusClickHandler = this.qtyButtonPlusClickHandler.bind(this);
        this.qtyButtonMinusClickHandler = this.qtyButtonMinusClickHandler.bind(this);
      }

      connectedCallback() {
        this.lineId = this.dataset.id;
        this.builderBundleId = this.dataset.builderBundleId || "";
        this.builderRole = this.dataset.builderRole || "";
        this.qtyInput = this.querySelector(".js-cart-item__form-qty-input");
        this.qtyButtonPlus = this.querySelector(".js-cart-item__form-qty-button--plus");
        this.qtyButtonMinus = this.querySelector(".js-cart-item__form-qty-button--minus");
        this.removeBtn = this.querySelector(".js-cart-item__remove");

        if (this.removeBtn) this.removeBtn.addEventListener("click", this.removeBtnClickHandler);
        if (this.qtyButtonPlus) this.qtyButtonPlus.addEventListener("click", this.qtyButtonPlusClickHandler);
        if (this.qtyButtonMinus) this.qtyButtonMinus.addEventListener("click", this.qtyButtonMinusClickHandler);
        if (this.qtyInput) this.qtyInput.addEventListener("change", this.qtyInputChangeHandler);
      }

      disconnectedCallback() {
        if (this.qtyButtonPlus) this.qtyButtonPlus.removeEventListener("click", this.qtyButtonPlusClickHandler);
        if (this.qtyButtonMinus) this.qtyButtonMinus.removeEventListener("click", this.qtyButtonMinusClickHandler);
        if (this.qtyInput) this.qtyInput.removeEventListener("change", this.qtyInputChangeHandler);
        if (this.removeBtn) this.removeBtn.removeEventListener("click", this.removeBtnClickHandler);
      }

      removeBtnClickHandler() {
        this.updateCartQuantity(0);
      }

      qtyInputChangeHandler() {
        var nextQuantity = this.clampedQuantity();
        this.qtyInput.value = nextQuantity;
        this.updateQuantityButtons(nextQuantity);
        this.updateCartQuantity(nextQuantity);
      }

      qtyButtonPlusClickHandler() {
        this.qtyInput.value = parseInt(this.qtyInput.value, 10) + 1;
        this.qtyInput.dispatchEvent(new Event("change"));
      }

      qtyButtonMinusClickHandler() {
        this.qtyInput.value = parseInt(this.qtyInput.value, 10) - 1;
        this.qtyInput.dispatchEvent(new Event("change"));
      }

      clampedQuantity() {
        var quantity = parseInt(this.qtyInput.value, 10);
        var min = parseInt(this.qtyInput.min, 10);
        var max = parseInt(this.qtyInput.max, 10);

        if (!Number.isFinite(quantity)) quantity = Number.isFinite(min) ? min : 1;
        if (Number.isFinite(max) && quantity > max) quantity = max;
        if (Number.isFinite(min) && quantity < min) quantity = min;

        return quantity;
      }

      updateQuantityButtons(quantity) {
        var min = parseInt(this.qtyInput.min, 10);
        var max = parseInt(this.qtyInput.max, 10);

        if (Number.isFinite(max) && quantity === max) {
          if (this.qtyButtonPlus) this.qtyButtonPlus.classList.add("c-cart-item__form-qty-button--disabled");
        } else if (this.qtyButtonPlus) {
          this.qtyButtonPlus.classList.remove("c-cart-item__form-qty-button--disabled");
        }

        if (Number.isFinite(min) && quantity === min) {
          if (this.qtyButtonMinus) this.qtyButtonMinus.classList.add("c-cart-item__form-qty-button--disabled");
        } else if (this.qtyButtonMinus) {
          this.qtyButtonMinus.classList.remove("c-cart-item__form-qty-button--disabled");
        }
      }

      updateCartQuantity(quantity) {
        if (this.builderRole === "parent" && this.builderBundleId) {
          this.updateBuilderBundleQuantity(quantity);
          return;
        }

        this.updateSingleLineQuantity(quantity);
      }

      updateBuilderBundleQuantity(quantity) {
        fetch("/cart.js", {
          headers: {
            Accept: "application/json"
          }
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (cart) {
            var updates = {};
            (cart.items || []).forEach(function (item) {
              if (cartItemBundleId(item) === this.builderBundleId) {
                updates[item.key] = quantity;
              }
            }, this);

            if (!Object.keys(updates).length) updates[this.lineId] = quantity;
            return this.updateCartLines(updates);
          }.bind(this))
          .catch(function (error) {
            console.error("Error:", error);
            this.updateSingleLineQuantity(quantity);
          }.bind(this));
      }

      updateSingleLineQuantity(quantity) {
        var updates = {};
        updates[this.lineId] = quantity;
        return this.updateCartLines(updates);
      }

      updateCartLines(updates) {
        return fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            updates: updates
          })
        })
          .then(function (response) {
            return response.json();
          })
          .then(function () {
            if (window.PubSub && typeof window.PubSub.publish === "function") {
              window.PubSub.publish("cart:update", "");
            }
          })
          .catch(function (error) {
            console.error("Error:", error);
          });
      }
    }
  );
}

function cartItemBundleId(item) {
  return cartItemPropertyValue(item, ["Builder Bundle ID", "_Builder Bundle ID"]);
}

function cartItemParentVariant(item) {
  return cartItemPropertyValue(item, ["Builder Parent Variant", "_Builder Parent Variant"]);
}

function cartItemPropertyValue(item, names) {
  if (!item || !item.properties) return "";
  if (Array.isArray(item.properties)) {
    for (var i = 0; i < item.properties.length; i += 1) {
      var property = item.properties[i];
      var key = property && (property[0] || property.name || property.key);
      if (names.indexOf(key) !== -1) {
        return String(property[1] || property.value || "");
      }
    }
    return "";
  }

  for (var j = 0; j < names.length; j += 1) {
    if (item.properties[names[j]]) return String(item.properties[names[j]]);
  }
  return "";
}

function cleanupOrphanBuilderLines() {
  if (!document.querySelector("s-main-cart")) return;

  fetch("/cart.js", {
    headers: {
      Accept: "application/json"
    }
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (cart) {
      var items = cart.items || [];
      var parentBundleIds = {};
      var updates = {};

      items.forEach(function (item) {
        var bundleId = cartItemBundleId(item);
        if (bundleId && !cartItemParentVariant(item)) parentBundleIds[bundleId] = true;
      });

      items.forEach(function (item) {
        var bundleId = cartItemBundleId(item);
        if (bundleId && cartItemParentVariant(item) && !parentBundleIds[bundleId]) {
          updates[item.key] = 0;
        }
      });

      if (!Object.keys(updates).length) return null;

      return fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          updates: updates
        })
      });
    })
    .then(function (response) {
      if (response && window.PubSub && typeof window.PubSub.publish === "function") {
        window.PubSub.publish("cart:update", "");
      }
    })
    .catch(function (error) {
      console.error("Error:", error);
    });
}

if (!window.__smcbOrphanBuilderLineCleanup) {
  window.__smcbOrphanBuilderLineCleanup = true;
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", cleanupOrphanBuilderLines);
  } else {
    cleanupOrphanBuilderLines();
  }
}
